import Support from '../../../utils/support';

export default function (moving) {
  const swiper = this;
  if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) return;
  const el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/framework7/components/swiper/swiper-class/components/core/grab-cursor/setGrabCursor.js
// module id = null
// module chunks = 